import styled from 'styled-components';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import EmailIcon from '@mui/icons-material/Email';
import { Bio } from '../../data/constant';

const FooterContainer = styled.div`
    width: 100%;
    padding: 2rem 0;
    display: flex;
    justify-content: center;
`;

const FooterWrapper = styled.footer`
    width: 100%;
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    align-items: center;
    padding: 1rem;
    color: ${({ theme }) => theme.text_primary};
`;

const Logo = styled.h1`
    font-weight: 600;
    font-size: 20px;
    color: ${({ theme }) => theme.primary};
`;

const Nav = styled.nav`
    width: 100%;
    max-width: 800px;
    margin-top: 0.5rem;
    display: flex;
    flex-direction: row;
    gap: 2rem;
    justify-content: center;
    @media (max-width: 768px) {
        flex-wrap: wrap;
        gap: 1rem;
        justify-content: center;
        text-align: center;
        font-size: 12px;
    }
`;

const NavLink = styled.a`
    color: ${({ theme }) => theme.text_primary};
    text-decoration: none;
    font-size: 1.2rem;
    transition: color 0.2s ease-in-out;
    &:hover {
        color: ${({ theme }) => theme.primary};
    }
    @media (max-width: 768px) {
        font-size: 1rem;
    }
`;

const SocialMediaIcons = styled.div`
    display: flex;
    margin-top: 1rem;
    gap: 1rem;
`;

const SocialMediaIcon = styled.a`
    display: inline-block;
    font-size: 1.5rem;
    color: ${({ theme }) => theme.text_primary};
    transition: color 0.2s ease-in-out, transform 0.2s ease-in-out;
    &:hover {
        color: ${({ theme }) => theme.primary};
        transform: scale(1.15);
    }
`;

const Copyright = styled.p`
    margin-top: 1.5rem;
    font-size: 0.9rem;
    color: ${({ theme }) => theme.soft2};
    text-align: center;
`;

function Footer() {
    return (
        <FooterContainer>
            <FooterWrapper>
                <Logo>Tarun Bhalla</Logo>
                <Nav>
                    <NavLink href="#about">Home</NavLink>
                    <NavLink href="#experience">Experience</NavLink>
                    <NavLink href="#projects">Projects</NavLink>
                    <NavLink href="#skills">Skills</NavLink>
                    <NavLink href="#education">Education</NavLink>
                </Nav>
                <SocialMediaIcons>
                    <SocialMediaIcon href={Bio.linkedin} target="_blank" rel="noopener noreferrer">
                        <LinkedInIcon />
                    </SocialMediaIcon>
                    <SocialMediaIcon href={Bio.github} target="_blank" rel="noopener noreferrer">
                        <GitHubIcon />
                    </SocialMediaIcon>
                    <SocialMediaIcon href={Bio.email}>
                        <EmailIcon />
                    </SocialMediaIcon>
                </SocialMediaIcons>
                <Copyright>
                    &copy; {new Date().getFullYear()} Tarun Bhalla. Built with React.
                </Copyright>
            </FooterWrapper>
        </FooterContainer>
    );
}

export default Footer;